<template>
  <div class="bill-detail">
    <!-- Header -->
    <div class="bill-header">
      <div class="bill-info">
        <div>
          <span class="bill-info-label">学生电话:</span><span>{{ studentPhone }}</span>
        </div>
        <div>
          <span class="bill-info-label">日期: </span><span>{{ billDate }}</span>
        </div>
      </div>
    </div>

    <!-- Course Price Details Table -->
    <div class="bill-section">
      <div class="section-title">课程价格明细</div>
      <div class="bill-courselist">
        <el-table :data="coursePriceDetails" border :show-header="true" class="bill-table" :cell-style="getCellStyle"
          :header-row-class-name="'el-table-header'">
          <el-table-column prop="courseCode" label="课程代码" width="200" align="center" />
          <el-table-column prop="coursePrice" label="课程价格" width="120" align="center">
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.coursePrice) }}
            </template>
          </el-table-column>
          <el-table-column v-if="hasDiscount" prop="discountAmount" label="优惠金额" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.discountAmount !== 0" class="cs-redLabel">
                {{ formatCurrency(-scope.row.discountAmount) }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column v-if="hasDiscount" prop="discountedPrice" label="折后价格" width="120" align="center">
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.discountedPrice) }}
            </template>
          </el-table-column>
          <el-table-column v-if="hasDiscount" prop="correspondingDiscount" label="对应折扣" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.correspondingDiscount">{{ scope.row.correspondingDiscount }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column  v-if="hasCouponDiscount" prop="couponDiscountDollar" label="使用代金券" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.couponDiscountDollar !== 0" class="cs-redLabel">
                {{ formatCurrency(-scope.row.couponDiscountDollar) }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- Pre-tax Tuition Summary -->
    <div class="bill-section">
      <div class="section-title">税前学费总结</div>
      <div class="summary-row">
        <div class="summary-label">税前价格合计:</div>
        <div class="summary-value cyan-text">{{ formatCurrency(totalPreTaxPrice) }}</div>
      </div>
      <div class="summary-row" v-if="shouldShowDiscountSummary">
        <div class="summary-label">优惠金额合计:</div>
        <div class="summary-value cs-redLabel">{{ formatCurrency(-totalDiscountAmount) }}</div>
      </div>
      <div class="summary-row" v-if="shouldShowDiscountSummary">
        <div class="summary-label">税前折后总价:</div>
        <div class="summary-value cyan-text">{{ formatCurrency(totalPreTaxPriceAfterDiscount) }}</div>
      </div>
      <div class="summary-row" v-if="additionalDeduction !== 0">
        <div class="summary-label">额外减免:</div>
        <div class="summary-value cs-redLabel">{{ formatCurrency(additionalDeduction) }}</div>
      </div>
      <div class="summary-row" v-if="bonusPointUsed !== 0">
        <div class="summary-label">使用账户积分:</div>
        <div class="summary-value cs-redLabel">
          {{ formatCurrency(bonusPointUsed) }}
          <span class="points-note">({{ pointsNote }})</span>
        </div>
      </div>
      <div class="summary-row" v-if="shouldShowPreTaxPayable || bonusPointUsed !== 0">
        <div class="summary-label">税前需缴:</div>
        <div class="summary-value cyan-text">{{ formatCurrency(dataIn.accountDiscountAmount) }}</div>
      </div>
      <div class="summary-row">
        <div class="summary-label">税费Sales Tax ({{ dataIn.taxModel.taxRate | toPercent}}):</div>
        <div class="summary-value">{{ formatCurrency(salesTax) }}</div>
      </div>

      <div class="summary-row" v-if="balanceUsed !== 0">
        <div class="summary-label">使用账户余额:</div>
        <div class="summary-value">
          <span class="cs-redLabel">{{ formatCurrency(balanceUsed) }}</span>
          (<span>可使用余额:{{ formatCurrency(this.dataIn.balanceTotal) }},</span>
          <span>扣完剩余余额:{{ formatCurrency(balanceLeft) }}</span>)
        </div>
      </div>

      <div class="summary-row" v-if="enrollmentUsed !== 0">
        <div class="summary-label">使用占位费:</div>
        <div class="summary-value cs-redLabel">
          {{ formatCurrency(enrollmentUsed) }}
          <span class="points-note">({{ enrollmentNote }})</span>
        </div>
      </div>
    </div>

    <!-- Total Payable Tuition -->
    <div class="bill-section">
      <div class="summary-row summary-row-total">
        <div class="summary-label">应付学费:</div>
        <div class="summary-value total-amount">{{ formatCurrency(dataIn.accountAmount) }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bill-detail {
  padding: 20px 40px 20px 40px;
  background: #f5f7fa;
  font-size: 14px;
}

.bill-header {
  margin-bottom: 20px;

  .bill-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .bill-info {
    display: flex;
    gap: 10px;
    font-size: 14px;
    flex-direction: column;

    .bill-info-label {
      width: 150px;
      font-weight: bold;
      display: inline-block;
    }
  }
}

.bill-section {
  margin-bottom: 20px;
  &:last-of-type{
    margin-bottom: 0;
  }

  .section-title {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 16px;
  }

  .bill-courselist{
    width: auto; 
    display: inline-block;

  }
}

.bill-table {
  background: #f5f7fa;
  width: auto; 
  table-layout: auto;

  ::v-deep .el-table__header {
    th {
      background-color: #c9c9c9;
      font-weight: bold;
      text-align: center;
    }
  }

}

.summary-row {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  min-height: 30px;

  .summary-label {
    width: 150px;
    font-weight: bold;
  }

  .summary-value {
    flex: 1;
    text-align: left;
    font-weight: 500;

    &.total-amount {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .summary-note {
    font-size: 12px;
    color: #666;
    margin-left: 10px;
    font-style: italic;
  }

  .points-note {
    font-size: 12px;
    margin-left: 5px;
  }

  &.summary-row-total{
    
    .summary-label {
      font-size: 18px;
    }
    .summary-value{
      font-size: 18px;
    }
  }
}

.cyan-text {
  color: #00bcd4;
}

</style>

<script>
export default {
  name: "BillDetail",
  props: {
    dataIn: {
      type: Object,
      required: true,
      default: () => ({
        discountNames: "",
        courseList: [],
        courseOriginalPrice: 0,
        courseTotalDiscountPrice: 0,
        courseTotalDecreaseAmount: 0,
        workflowRelatedDicountAmount: 0,
        balance: 0,
        bonusPointAmount: 0,
        enrollmentCountAmount: 0,
        enrollmentCountUsed: 0,
        accountDiscountAmount: 0,
        taxModel: {
          hasTax: false,
          taxRate: 0,
          courseTotalTax: 0
        },
        accountAmount: 0,
        balanceTotal: 0
      })
    },
    studentPhone: {
      type: String,
      default: ""
    },
    billDate: {
      type: String,
      default: () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      }
    }
  },
  computed: {
    hasDiscount() {
      return !!this.dataIn && !!this.dataIn.discountNames || (this.totalDiscountAmount > 0);
    },
    hasCouponDiscount(){
      if (!this.dataIn || !this.dataIn.courseList) {
        return false;
      }
      return this.dataIn.courseList.findIndex(i => i.priceData.couponDiscountDollar > 0) >= 0;
    },
    // Course price details for table
    coursePriceDetails() {
      if (!this.dataIn || !this.dataIn.courseList) {
        return [];
      }

      let list = this.dataIn.courseList.slice().sort((a, b) => {
        const ratioA = a.priceData.discountPrice / a.priceData.price;
        const ratioB = b.priceData.discountPrice / b.priceData.price;
        return ratioA - ratioB; // 从小到大排序
      });
      return list.map(course => {
        const coursePrice = (course.priceData && course.priceData.price) || 0;
        const discountPrice = (course.priceData && course.priceData.discountPrice) || 0;
        const discountAmount = coursePrice - discountPrice;
        const couponDiscountDollar = (course.priceData && course.priceData.couponDiscountDollar) || 0;

        return {
          courseCode: course.courseName || course.courseCode || "",
          coursePrice: coursePrice,
          discountAmount: discountAmount,
          discountedPrice: discountPrice,
          correspondingDiscount: this.calculateDiscount(coursePrice, discountPrice),
          couponDiscountDollar: couponDiscountDollar
        };
      });
    },

    // Total pre-tax price (sum of all course prices)
    totalPreTaxPrice() {
      return this.coursePriceDetails.reduce((sum, item) => sum + item.coursePrice, 0);
    },

    // Total discount amount
    totalDiscountAmount() {
      return this.coursePriceDetails.reduce((sum, item) => sum + item.discountAmount + item.couponDiscountDollar, 0);
    },

    // Total pre-tax price after discount
    totalPreTaxPriceAfterDiscount() {
      return this.totalPreTaxPrice - this.totalDiscountAmount;
    },

    // Should show discount summary (only if there's a difference)
    shouldShowDiscountSummary() {
      return Math.abs(this.totalPreTaxPrice - this.totalPreTaxPriceAfterDiscount) > 0.01;
    },

    // Additional deduction (额外减免)
    additionalDeduction() {
      let deduction = -(this.dataIn.CashDecreasedAmount || 0);
      // Add workflow related discount if it's a discount (positive value)
      if (this.dataIn.workflowRelatedDicountAmount > 0) {
        deduction -= this.dataIn.workflowRelatedDicountAmount;
      }
      return deduction;
    },
    // Should show pre-tax payable section
    shouldShowPreTaxPayable() {
      return this.shouldShowDiscountSummary || this.additionalDeduction !== 0;
    },

    // Sales tax
    salesTax() {
      if (this.dataIn.taxModel && this.dataIn.taxModel.hasTax) {
        return this.dataIn.taxModel.courseTotalTax || 0;
      }
      return 0;
    },

    // Account balance used
    balanceUsed() {
      return -(this.dataIn.balance || 0);
    },

    // Account points used
    bonusPointUsed() {
      return -(this.dataIn.bonusPointAmount || 0);
    },

    // Points note
    pointsNote() {
      const points = this.dataIn.bonusPointAmount || 0;
      // Assuming 1 point = $0.05 (adjust based on actual conversion rate)
      const pointValue = points / 0.05;
      return `-${pointValue}分`;
    },

    enrollmentUsed() {
      return -(this.dataIn.enrollmentCountAmount || 0);
    },

    enrollmentNote() {
      return `-${this.dataIn.enrollmentCountUsed}个`;
    },

    balanceLeft(){
      const balanceTotal = this.dataIn.balanceTotal || 0;
      const balance = this.dataIn.balance || 0;
      let value = balanceTotal - balance;
      if (value < 0){
        value = 0;
      }
      return value;
    }
  },
  methods: {
    formatCurrency(value) {
      if (value == null || isNaN(value)) {
        return "$0.00";
      }
      const absValue = Math.abs(value);
      const formatted = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // Format as $1,000.00 or -$1,000.00
      return value < 0 ? "-$" + formatted : "$" + formatted;
    },
    calculateDiscount(price, discountPrice) {
      if (isNaN(price) || isNaN(discountPrice) || price < 0 || discountPrice < 0) {
        return "";
      }

      if (discountPrice > price) {
        return "";
      }

      if (price == 0 || discountPrice == price ||
        (discountPrice >= price - 0.1 && discountPrice <= price + 0.1)) {
        return "";
      }

      // Calculate discount ratio (e.g., 0.8 = 8折)
      const discountRate = (discountPrice / price) * 10;

      // Format discount display
      let discountText;
      if (discountRate % 1 === 0) {
        discountText = `(${discountRate.toFixed(0)}折)`;
      } else {
        discountText = `(${(discountRate * 10).toFixed(0)}折)`;
      }

      return discountText;
    },

    getCellStyle({ row, column, rowIndex, columnIndex }) {
      // Style for discount amount and voucher used columns
      if (column.property === 'discountAmount' || column.property === 'voucherUsed') {
        if (row[column.property] !== 0) {
          return { color: '#f56c6c' };
        }
      }
      return {};
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/billDetail.vue